import { useEffect, useState, createContext, useContext, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import ContactForm from "@/components/ContactForm";
import { Toaster } from "@/components/ui/sonner";
import { setLenis } from "@/lib/lenis";

const ContactContext = createContext({ openContact: () => {} });
export const useContact = () => useContext(ContactContext);

function App() {
  const [open, setOpen] = useState(false);
  const [defaultPackage, setDefaultPackage] = useState("");

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, wheelMultiplier: 0.9 });
    setLenis(lenis);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      setLenis(null);
      lenis.destroy();
    };
  }, []);

  const openContact = useCallback((pkg = "") => {
    setDefaultPackage(pkg);
    setOpen(true);
  }, []);

  return (
    <ContactContext.Provider value={{ openContact }}>
      <div className="App">
        <Landing />
        <ContactForm open={open} onOpenChange={setOpen} defaultPackage={defaultPackage} />
        <Toaster position="top-center" richColors closeButton />
      </div>
    </ContactContext.Provider>
  );
}

export default App;
